import { Address } from "./address";

export class GeoAddress {
    latitude!: number;
    longitude!: number;
    providedAddress!: string;
    relevance!: number;
    address!: Address;
  }